// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"57505937","266":"54d778c4","738":"e7a42c9d","794":"96a50837","808":"a7caa808","809":"b0583276","838":"e7a42c9d"}[chunkId] + ".chunk.css";
};